export default [
  {
    title: "Roll",
    key: "ROLE",
    visited: true,
    hasError: false,
    fieldKeys: ["title"],
  },
];
